<template>
  <div id="xspreadsheet" style="width:1000px;"></div>
</template>
<script>
import { onMounted } from 'vue'
export default {
  setup() {
    onMounted(() => {
      // eslint-disable-next-line no-undef
      x_spreadsheet('#xspreadsheet', {
        view: {
          height: () => document.documentElement.clientHeight - 150,
          width: () => document.documentElement.clientWidth - 320
        }
      })
    })
    return {}
  }
}
</script>
